[
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "fi",
  "fr",
  "hu",
  "it",
  "nl",
  "no",
  "pl",
  "pt-br",
  "pt",
  "ro",
  "ru",
  "sv",
  "tr"
]
